@for (motd of activeMotdList; track motd; let i = $index) {
<ngb-toast (hide)="dismiss(motd.id)" delay="120000" #motdToasts>
    <ng-template ngbToastHeader>
        <fa-icon class="me-2" [icon]="['fal', 'bullhorn']"></fa-icon>
        {{ motd.title ? motd.title : ('MOTD_TITLE' | translate) }}
    </ng-template>
    <p [innerHTML]="motd.message | safeHTML"></p>
</ngb-toast>
}
